<div class="container-box">
  <app-table-header
    (btnUpdateClick)="reloadTrigger$.next()"
    tableTitle="Vetture aziendali Paolo Crespi"
  ></app-table-header>
  <div>
    <div class="table-container">
      <app-new-table
        (btnDetailsClickEvent)="btnDetailsClickFunction($event)"
        (customActionSlideToggle)="updateRentable($event)"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [initialSort]="{
          active: 'id',
          direction: 'desc'
        }"
        [reloadTrigger$]="reloadTrigger$"
      ></app-new-table>
    </div>
  </div>
</div>
